export default "https://cdn.questicon.mathletics.com/assets/images/InCorrect-9c88bd8dc68c05c705fa7f070bf03fe7.svg";